import script from "./CaskDialogJudgment.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskDialogJudgment.vue?vue&type=script&setup=true&lang=js"

import "./CaskDialogJudgment.vue?vue&type=style&index=0&id=335e7a42&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QSeparator,QBtn});
